<div class="header-container">
  <!-- 
  We set the headerText as innerHTML so that others can insert tags to break lines
  See quick checkout component select-new-time state 
  -->
  <h2 class="calendar-header" data-test="book-a-session" [innerHTML]="headerText"></h2>
</div>

<div 
  *ngIf="soonestAvailableDate" 
  class="soonest-available" 
  data-test="soonest-available"
>
  <span>Soonest available: {{ soonestAvailableDate | date:'EEEE LLLL d' }}</span>
</div>

<div class="timezone" data-test="timezone">
  <p>{{ providerTimeZone | providerTimeZoneString }} timezone displayed</p>
</div>

<appointment-carousel
  [appointmentSlots]="appointmentSlots"
  (appointmentSlotSelectionChanged)="handleAppointmentSlotSelectionChanged($event)"
  (exitFocusFromCalendarEvent)="handleExitCalendarFocus()"  
>
</appointment-carousel>

<ng-container *ngIf="showSessionType">
  <iris-card class="session-type" data-test="session-type">
    <ng-template [ngTemplateOutlet]="sessionPreferences" />
  </iris-card>

  <div class="mobile-session-type">
    <hr>
    <ng-template [ngTemplateOutlet]="sessionPreferences" />
  </div>
</ng-container>

<iris-card-footer class="footer-button" [ngClass]="{'in-modal': isInModal}">  
  <div class="button-container">
    <iris-button
      id="book-calendar-slot-button"
      class="submit-button"
      [buttonType]="irisButtonTypes.PRIMARY"
      data-test="book-session-button"
      (click)="onSubmit()"
    >
      {{ submitButtonText }}
    </iris-button>
  </div>
</iris-card-footer>

<ng-template #sessionPreferences>
  <form *ngIf="isInModal" [formGroup]="providerCalendarFormGroupInModal">
    <iris-radio-group
      id="session-type-radio-group"
      [options]="sessionTypeOptions"
      formControlName="sessionTypePreferenceFromModal"
      aria-label="Session location preference"
    />
  </form>
  <form *ngIf="!isInModal" [formGroup]="providerCalendarFormGroup">
    <iris-radio-group
      id="session-type-radio-group"
      [options]="sessionTypeOptions"
      formControlName="sessionTypePreference"
      aria-label="Session location preference"
    />
  </form>
</ng-template>